import _ from "lodash";
import ApiClient from "../ApiClient";
import { apiPatch } from "../Api/apiCall";
import { getUpdateData, persistAddress } from "./persisterService";
import { persistAbstractCaseSubEntities } from "./AbstractCasePersister";
import { UseForm } from "../../types/UseForm";
import { Traffic } from "../../types/Products/TrafficLaw/Traffic/Traffic";

export const persistTraffic = async (updateData: UseForm["values"], origTraffic: Traffic) => {
  await persistAbstractCaseSubEntities(updateData, origTraffic);

  if (_.has(updateData, "petitioner.residenceAddress") && _.isObject(updateData.petitioner.residenceAddress)) {
    const petitionerAddressUpdateData = getUpdateData(
      updateData.petitioner.residenceAddress,
      origTraffic,
      "petitioner.residenceAddress"
    );
    !_.isEmpty(petitionerAddressUpdateData) &&
      (await persistAddress(origTraffic.petitioner.residenceAddress.id, petitionerAddressUpdateData));
  }

  if (
    _.has(updateData, "responsibleCourtAddress") &&
    _.isObject(updateData.responsibleCourtAddress) &&
    origTraffic.responsibleCourtAddress
  ) {
    const responsibleCourtAddressUpdateData = getUpdateData(
      updateData.responsibleCourtAddress,
      origTraffic,
      "responsibleCourtAddress"
    );
    !_.isEmpty(responsibleCourtAddressUpdateData) &&
      (await persistAddress(origTraffic.responsibleCourtAddress.id, responsibleCourtAddressUpdateData));
  }

  if (_.has(updateData, "investigation") && _.isObject(updateData.investigation) && origTraffic.investigation) {
    const investigationUpdateData = getUpdateData(updateData.investigation, origTraffic, "investigation");
    !_.isEmpty(investigationUpdateData) &&
      (await ApiClient.patch(`traffic_investigations/${origTraffic.investigation.id}`, {
        body: JSON.stringify(investigationUpdateData),
      }));
  }

  const trafficUpdateData = getUpdateData(updateData, origTraffic);
  await apiPatch("traffic", origTraffic.id, trafficUpdateData);
};
